"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_titlebar_1 = __importDefault(require("@tencent/odc-titlebar"));
var IconArrow_1 = __importDefault(require("./IconArrow"));
var MetasSecondary = function MetasSecondary(props) {
  var show = props.show,
    trigger = props.trigger,
    title = props.title,
    desc = props.desc,
    content = props.content,
    _a = props.onToggle,
    onToggle = _a === void 0 ? function () {
      return void 0;
    } : _a,
    hottag = props.hottag;
  var handleToggle = (0, react_1.useCallback)(function () {
    onToggle(!show);
  }, [onToggle, show]);
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('metas metas-secondary', {
      'metas--open': show
    }),
    supportAllEvents: true
  }, MetasSecondary)), react_1["default"].createElement("div", {
    className: "metas-mini",
    "data-hottag": hottag,
    onClick: handleToggle
  }, react_1["default"].createElement(IconArrow_1["default"], {
    className: "collapse-arrow odc-text-comment"
  }), title && desc ? react_1["default"].createElement(odc_titlebar_1["default"], {
    size: 6,
    title: title,
    titleClassName: 'font-medium',
    desc: desc,
    descType: 'comment'
  }) : trigger), react_1["default"].createElement("div", {
    className: "metas-all",
    style: {
      display: show ? 'block' : 'none'
    }
  }, content));
};
(0, spaui_utils_1.setComponentMark)(MetasSecondary, info_1["default"]);
exports["default"] = react_1["default"].memo(MetasSecondary);